(function (Drupal, $) {
  Drupal.behaviors.on_this_page = {
    attach: function (context) {
      $(function() {
        var sectionList = [];
        var hash = window.location.hash;

        $(once('section-list', '.field-on-this-page__list', context)).closest('.node__content').find('H2:not(.dont-show)').each(function() {
          sectionList.push($(this));
        })
        
        $(once('section-list-processed', '.field-on-this-page__list', context)).each(function(){
          if(sectionList.length > 2) {
            for (let i = 0; i < sectionList.length; i++) {
              var elem = sectionList[i];
              elem.attr('id', 'section-target-'+(i+1));
              $(this).append('<li><a href="#section-target-'+(i+1)+'">'+elem.text()+'</a></li>');
            }
            $('.field-on-this-page__content').fadeIn(300);

            if(hash) {
              $('html, body').stop().animate({
                'scrollTop': $(hash).offset().top
              });
            }
          }
          else {
            $(this).parent().parent().remove();
          }
        })
        
      });      
    }
  }
})(Drupal, jQuery);